import React from 'react';
import PropTypes from 'prop-types';
import { spring, TransitionMotion } from 'react-motion';

const hide = () => {
  return {
    opacity: spring(0),
    translateY: spring(-30),
    maxHeight: spring(0),
    marginTop: spring(0)
  };
};

const enter = () => ({
  opacity: 1,
  translateY: -30,
  maxHeight: 0
});

const TransitionWrapper = ({ children, ...props }) => (
  <TransitionMotion
    styles={React.Children.map(children, node => ({
      key: node && node.key,
      style: {
        opacity: spring(1),
        translateY: spring(0),
        maxHeight: spring(1000),
        marginTop: spring(8)
      },
      data: node
    }))}
    willEnter={enter}
    willLeave={hide}
  >
    {styles => {
      return (
        <div {...props}>
          {styles
            .filter(style => style.data)
            .map(({ data, style }) => {
              return React.cloneElement(data, {
                style: {
                  ...data.props.style,
                  opacity: style.opacity,
                  marginTop: style.marginTop,
                  transform: `translateY(${style.translateY}px)`,
                  maxHeight: style.maxHeight,
                  overflow: 'hidden'
                }
              });
            })}
        </div>
      );
    }}
  </TransitionMotion>
);

TransitionWrapper.propTypes = {
  children: PropTypes.node
};
export default TransitionWrapper;
